import { cn } from '@saas-pages/shared/ui'

interface OptionToggleProps {
  label: string
  description: string
  checked: boolean
  onChange: () => void
  type?: 'checkbox' | 'radio'
  name?: string
}

/** Compact option chip: the description appears from `sm:` up, where there is room for it. */
export function OptionToggle({
  label,
  description,
  checked,
  onChange,
  type = 'checkbox',
  name,
}: OptionToggleProps) {
  return (
    <label
      title={description}
      className={cn(
        'flex min-h-11 min-w-0 cursor-pointer items-start gap-2.5 rounded-lg border px-3 py-2 transition-colors',
        'hover:bg-accent/40 focus-within:ring-2 focus-within:ring-ring',
        checked ? 'border-primary/40 bg-primary/[0.04]' : 'border-border bg-card',
      )}
    >
      <input
        type={type}
        name={name}
        checked={checked}
        onChange={onChange}
        className="mt-0.5 size-4 shrink-0 accent-primary"
      />
      <span className="min-w-0">
        <span className="block text-sm font-medium leading-5">{label}</span>
        <span className="mt-0.5 hidden text-xs leading-5 text-muted-foreground sm:block">
          {description}
        </span>
      </span>
    </label>
  )
}
